module.exports = __webpack_public_path__ + "img/mark-lyle.c558dbb2.png";